import { useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiError } from "@/lib/api";
import { advisorApi, advisorToken } from "@/lib/advisorApi";
import { AdvisorAuthShell, AuthFooterLink } from "@/components/asesor/AdvisorAuthShell";

export default function AdvisorLogin() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(params.get("expirada") ? "Tu sesión expiró. Vuelve a entrar." : "");
  const [submitting, setSubmitting] = useState(false);

  if (advisorToken.get()) return <Navigate to="/asesor" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const { data } = await advisorApi.post("/asesor/auth/login", { correo: correo.trim().toLowerCase(), password });
      advisorToken.set(data.token);
      nav("/asesor", { replace: true });
    } catch (err) {
      const msg = formatApiError(err, "Correo o contraseña incorrectos");
      setError(msg);
      toast.error(msg);
    } finally { setSubmitting(false); }
  }

  return (
    <AdvisorAuthShell title="Iniciar sesión" subtitle="Consulta los clientes que te asignó Dupla Automotriz." testId="page-asesor-login">
      <form onSubmit={onSubmit} className="space-y-4" data-testid="asesor-login-form">
        <div><Label className="field-label">Correo</Label><Input type="email" required autoComplete="username" value={correo} onChange={(e) => setCorreo(e.target.value)} data-testid="asesor-login-email" /></div>
        <div><Label className="field-label">Contraseña</Label><Input type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="asesor-login-password" /></div>
        {error && <p className="rounded-sm bg-red-50 p-3 text-xs text-red-700" data-testid="asesor-login-error">{error}</p>}
        <button type="submit" disabled={submitting} className="btn-primary w-full disabled:opacity-60" data-testid="asesor-login-submit">
          {submitting ? "Entrando..." : "Entrar"}
        </button>
      </form>
      <AuthFooterLink to="/asesor/olvide-contrasena" testId="asesor-forgot-link">Olvidé mi contraseña</AuthFooterLink>
    </AdvisorAuthShell>
  );
}
